import React from 'react';
import './reviewCard.css';
import filledStar from '../../assets/icons/starFill.svg';

const ReviewCard = (props) => {
    return ( 
        <>
        <div className="reviewCard">
            <div className="stars">
                <img src={filledStar} alt="star icon" />
                <img src={filledStar} alt="star icon" />
                <img src={filledStar} alt="star icon" />
                <img src={filledStar} alt="star icon" />
                <img src={filledStar} alt="star icon" />
            </div>
            <h6 className='body'>{props.review}</h6>
            <h5 className='body'>{props.reviewer}</h5>
        </div>
        </>
     );
}
 
export default ReviewCard;